var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandScglab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 30,
    viewBox: "0 0 122 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 121.799,
    height: 30.0003,
    transform: "translate(0.100342)",
    fill: "#059DE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63666 20.9467L7.80849 19.324C8.59024 20.754 10.0453 21.5708 11.7283 21.5708C13.694 21.5708 15.1814 20.5836 15.1814 19.1883C15.1814 17.4974 12.8795 16.4762 10.8379 15.5571C8.78562 14.6034 6.50537 13.4916 6.50537 10.6207C6.50537 7.62519 8.99191 5.53711 12.141 5.53711C14.6384 5.53711 16.5061 6.79672 17.223 8.80507L15.1814 10.2801C14.6384 9.0436 13.4332 8.35137 12.1627 8.35137C10.5557 8.35137 9.27424 9.39515 9.27424 10.6889C9.27424 12.1188 10.8922 12.6292 13.0206 13.5822C15.7895 14.8535 17.9396 16.2493 17.9396 19.1311C17.9396 22.3767 15.2467 24.4647 11.6957 24.4647C8.81812 24.4647 6.63562 23.0573 5.63666 20.9467Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8324 15.0237C19.8324 9.86567 24.2129 5.53711 29.4486 5.53711C31.864 5.57111 34.0947 6.58216 35.9209 8.3317L34.2219 10.5927C32.9158 9.30914 31.2168 8.45656 29.3907 8.45656C26.0158 8.45656 22.7911 11.365 22.7911 15.0347C22.7911 18.7275 26.0622 21.5788 29.4022 21.5788C31.3093 21.5788 32.9505 20.6475 34.2334 19.3974L35.9209 21.7152C34.3144 23.2717 32.2686 24.4647 29.4947 24.4647C24.2129 24.4647 19.8324 20.1928 19.8324 15.0237Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9021 15.5916C53.9021 21.0339 50.0105 24.4647 45.3251 24.4647C40.0805 24.4647 35.9209 20.2155 35.9209 15.0234C35.9209 9.82052 40.1029 5.53711 45.2244 5.53711C47.4946 5.54866 50.0887 6.66182 51.7887 8.34318L50.2119 10.729C48.8028 9.32046 46.9019 8.43442 45.1908 8.43442C41.9034 8.43442 38.7946 11.2291 38.7946 15.0234C38.7946 18.6139 41.6015 21.5674 45.4482 21.5674C48.5457 21.5674 50.8717 19.6473 50.8717 16.8528V16.7962H45.2915V14.16H53.824C53.8686 14.5808 53.9021 15.0807 53.9021 15.5916Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2399 21.6529V24.4637H72.8297V6.48242H75.5395V21.6529H83.2399Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6021 12.4949L89.2997 24.4647H86.0791L94.513 5.53711H94.6799L103.114 24.4647H99.8814L94.6021 12.4949Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.489 21.7086H106.853V16.1982L110.445 16.1869C112.473 16.1869 113.626 17.4364 113.626 18.7974C113.626 20.5373 112.096 21.7086 110.489 21.7086ZM106.853 9.22683H110.318C111.582 9.22683 112.69 10.1858 112.69 11.4683C112.69 12.7513 111.671 13.7103 110.285 13.6996L106.853 13.7103V9.22683ZM113.309 14.5528C114.214 14.3627 115.317 12.9104 115.317 11.1006C115.317 8.71316 113.234 6.48242 110.152 6.48242H104.06V14.3352V24.4637H110.744C114.291 24.4637 116.363 21.742 116.363 18.9869C116.363 16.7464 114.915 15.1161 113.309 14.5528Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4731 13.1078H65.2587V9.32227H61.4731V13.1078Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4731 20.6801H65.2587V16.8945H61.4731V20.6801Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6876 16.8949H61.4731V13.1094H57.6876V16.8949Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2587 16.8949H69.0443V13.1094H65.2587V16.8949Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandScglab);
export default __webpack_public_path__ + "static/media/brand-scglab.d08cf833e9fd3f54aaa8361b59568b52.svg";
export { ForwardRef as ReactComponent };